/**
 * PopoverFooter
 * Shared APPLY / Reset button row for filter popovers.
 */

export function PopoverFooter({ onApply, onReset }: { onApply: () => void; onReset: () => void }) {
  return (
    <div className="flex items-center gap-[15px]">
      <button
        type="button"
        onClick={onApply}
        className="h-[50px] w-[110px] rounded-full bg-text-primary text-my-rituality-bg text-[14px] font-semibold uppercase"
      >
        Apply
      </button>
      <button type="button" onClick={onReset} className="text-[14px] font-semibold text-white">
        Reset
      </button>
    </div>
  )
}
